/* eslint-disable no-restricted-properties */

import { createEnv } from "@t3-oss/env-core"
import { createCIEnvValidationHandler } from "@ucr/utils/environment/envValidationHandler"
import { z } from "zod"

export function authEnv(NOT_AVAILABLE_ON_CI: string[]) {
  return createEnv({
    emptyStringAsUndefined: true,
    server: {
      AUTH_SECRET: z.string({
        required_error:
          "This is a secret that is used for de-/encryption of next auch jwt token, generate via: 'openssl rand -base64 64' - if you want to build local for staging/production, create a .env.staging.local file for the secret",
      }),
    },
    client: {},
    clientPrefix: "NEXT_PUBLIC_",
    runtimeEnv: {
      // If new env variables are added and get an ESLINT error for turbo/... add them to the root turbo.json globalEnv array and restart ESLINT service of editor if error stays

      AUTH_SECRET: process.env.AUTH_SECRET,
    },

    onValidationError: createCIEnvValidationHandler(["AUTH_SECRET", ...NOT_AVAILABLE_ON_CI]),
  })
}
